import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  grow: {
    display: 'flex',
    marginBottom: '15px',
    justifyContent: 'space-between',
  },
  button: {
    marginLeft: '10px',
    minWidth: '110px',
  },
  divButton: {
    display: 'flex',
    justifyContent: 'center',
  },
  buttonFilter: {
    marginLeft: '10px',
    width: '80px',
  },
}))

export default useStyles
